module.exports = __webpack_public_path__ + "static/media/riskpic3@3x.a7715bb3.png";